import { memo } from "react";
import { BRUSH_BOT_Y, BRUSH_TOP_Y, BRUSH_X } from "../constants";
import paintbrushIcon from "../assets/images/paintbrush.webp";

interface PaintbrushProps {
  progress: number;
  stroking: boolean;
}

function PaintbrushComponent({ progress, stroking }: PaintbrushProps) {
  const brushY = BRUSH_BOT_Y - (progress / 100) * (BRUSH_BOT_Y - BRUSH_TOP_Y);

  // At 100% use clean ease-out to avoid spring overshoot snap
  const positionTransition =
    progress === 100
      ? "transform 0.6s ease-out"
      : "transform 0.7s cubic-bezier(0.34, 1.56, 0.64, 1)";

  return (
    <div
      style={{
        position: "absolute",
        left: "35%",
        top: "80%",
        transform: `translate(calc(-50% + ${BRUSH_X}px), calc(-50% + ${brushY - 120}px))`,
        transition: positionTransition,
        zIndex: 20,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          // "forwards" holds the last keyframe before brushFloat takes over
          animation: stroking
            ? "brushStroke 0.35s ease-out forwards"
            : "brushFloat 2.5s ease-in-out infinite",
          transformOrigin: "center bottom",
        }}
      >
        <img src={paintbrushIcon} alt="paint" className="w-full max-w-[135px]" />
      </div>
    </div>
  );
}

export const Paintbrush = memo(PaintbrushComponent);
export default Paintbrush;
